import device from "src/constants/media";
import { colors } from "src/theme";
import styled from "styled-components";
import { FlexColumn } from "../../common";

export const overlay = {
  zIndex: 3000,
  backgroundColor: "rgba(46, 46, 46, 0.75)",
};

export const content = {
  padding: "24px",
  borderRadius: "8px",
  inset: "20px 24px",
};

export const ContentContainer = styled(FlexColumn)`
  gap: 16px;
  min-height: 100%;
  place-items: center;
  @media ${device.laptopS} {
    gap: 24px;
    place-content: center;
  }
`;

export const CardButton = styled.button<{ selected: boolean; flexDirection?: "column" | "row" }>`
  border-radius: 8px;
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || "column"};
  gap: 12px;
  min-width: fit-content;
  padding: 16px 12px;
  place-content: center;
  place-items: ${({ flexDirection }) => (flexDirection === "row" ? "start" : "center")};

  ${({ selected }) =>
    selected
      ? `
    background: ${colors.mainLight};
    border: 2px solid ${colors.mainLight};
    `
      : `
    background: ${colors.white};
    border: 2px solid ${colors.greyVeryLight};
    :hover {
      border-color: ${colors.mainVeryLight};
      background: ${colors.mainVeryLight}
    }
    `}

  @media ${device.laptopS} {
    padding: 16px 24px;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  max-width: 600px;
  width: 100%;

  div {
    display: none !important;
  }

  @media ${device.laptopS} {
    grid-template-columns: 1fr 1fr;

    div {
      display: block !important;
    }
  }
`;

export const CountryCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
  place-content: center;
  width: 100%;
  @media ${device.laptopS} {
    flex-direction: row;
  }
`;

export const GradientBlock = styled.div`
  bottom: 0;
  height: 40px;
  position: sticky;
  margin-left: -24px;
  transform: translateY(24px);
  width: calc(100% + 48px);
  ::after {
    content: "";
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    bottom: 0;
    height: 64px;
    left: 0;
    position: absolute;
    right: 0;
  }
`;
